import React from 'react';
import Features from '@hpstellar/pdp/Features';

import withPageComponents from '../../../page/components/with-page-components';

const exclusiveFeatures = ({ exclusiveFeatures, category }) => {
    if (exclusiveFeatures) {
        return (
            <div className='pdp-features'>
                <Features
                    expandBtnText="See more features"
                    features={exclusiveFeatures}
                    mobileExpandBtnText="Features"
                    theme={category}
                    id='features'
                />
            </div>);
    }
    return null;
}

export default withPageComponents(exclusiveFeatures, { components: ['exclusiveFeatures'] })
